<script setup>
import { RouterView } from 'vue-router';
import ToastContainer from '@/components/ui/ToastContainer.vue';
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import DestructiveConfirm from '@/components/ui/DestructiveConfirm.vue';
import AnnouncementPopup from '@/components/announcements/AnnouncementPopup.vue';
// DEV-ONLY: tymczasowy switcher kont — usunąć przed handoffem.
import DevAccountSwitcher from '@/components/dev/DevAccountSwitcher.vue';

// Switcher kont: pod `npm run dev` (import.meta.env.DEV) oraz w buildzie lokalnym
// (runtime APP_ENV=local z meta-taga). Nigdy na produkcji. Trasy /dev/* i tak
// są gejtowane po stronie backendu na env=local.
const appEnv = document.querySelector('meta[name="app-env"]')?.content;
const isDev = import.meta.env.DEV || appEnv === 'local';
</script>

<template>
    <RouterView />
    <ToastContainer />
    <ConfirmDialog />
    <DestructiveConfirm />
    <AnnouncementPopup />
    <DevAccountSwitcher v-if="isDev" />
</template>
